export const EXECUTE_FIELD_EVENT = "kayros:execute-field";
export const FIELD_EXECUTED_EVENT = "kayros:field-executed";

const dispatchExecuted = (doc, detail) => {
  if (!doc || !doc.dispatchEvent) return;
  doc.dispatchEvent(new CustomEvent(FIELD_EXECUTED_EVENT, { detail }));
};

/**
 * `onExecuted` lets the host see what a screen executor returned (e.g. a
 * subscription the screen opened itself); its errors never reach the screen.
 */
export const bindExecuteFieldEvents = (
  doc,
  { execute, getProjectId, flush, onExecuted },
) => {
  if (!doc || !doc.addEventListener) return () => {};

  const onExecute = (event) => {
    const detail = (event && event.detail) || {};
    const key = detail.key;
    if (!key) return;
    const projectId = getProjectId && getProjectId();
    if (!projectId) {
      dispatchExecuted(doc, { key, ok: false, error: "NO_PROJECT" });
      return;
    }
    const run = () =>
      execute({
        key,
        entity: { id: projectId },
        args: { ...(detail.args || {}), project: { id: projectId } },
      });
    const started = flush ? Promise.resolve(flush()).then(run) : run();
    Promise.resolve(started)
      .then((result) => {
        if (onExecuted) {
          try {
            onExecuted({ key, result, stay: detail.stay === true });
          } catch (_error) {
            // The screen still gets its result.
          }
        }
        dispatchExecuted(doc, { key, ok: true, result });
      })
      .catch((error) => {
        dispatchExecuted(doc, {
          key,
          ok: false,
          error: error && error.message ? error.message : String(error),
        });
      });
  };

  doc.addEventListener(EXECUTE_FIELD_EVENT, onExecute);
  return () => {
    doc.removeEventListener(EXECUTE_FIELD_EVENT, onExecute);
  };
};
